(function (skyward, $, undefined)
{
    skyward.reporting = skyward.reporting || {};
    skyward.reporting.variables = skyward.reporting.variables || {};

    // Models
    skyward.reporting.variables.newVariableCollectionModel = function (variableCollectionData, lookupTables, reportCanvas)
    {
        var modelCollection = [];
        if (variableCollectionData)
        {
            variableCollectionData.forEach(function (v) { modelCollection.push(skyward.reporting.variables.newVariableModel(v, lookupTables, reportCanvas)); });
        }

        return skyward.mvvm.newModelCollection(modelCollection, {}, {}, function ()
        {
            var self = this;
            return {
                toJsonObject: function ()
                {
                    var results = [];
                    self.forEach(function (variable)
                    {
                        results.push(variable.toJsonObject());
                    });
                    return results;
                },
                getById: function (id)
                {
                    return self.find(function (variable) { return variable.uniqueId === id; });
                },
                idIsValidForAggregateMath: function (id)
                {
                    var variable = self.getById(id);
                    return variable && variable.isValidForAggregateMath();
                },
                nameExists: function (name, uniqueId)
                {
                    name = (name || "").toLowerCase();
                    var nameExists = false;
                    self.forEach(function (variable)
                    {
                        if (variable.uniqueId !== uniqueId && variable.name.toLowerCase() === name)
                        {
                            nameExists = true;
                            return false;
                        }
                    });
                    return nameExists;
                },
                _variableCollectionModel: "variable collection model"
            };
        });
    };

    skyward.reporting.variables.newVariableModel = function (variableData, lookupTables, reportCanvas)
    {
        var defaultValues = {
            uniqueId: "",
            name: "",
            dataTypeCategoryName: skyward.reporting.DATA_TYPES.STRING,
            defaultValue: ""
        };
        variableData = $.extend(defaultValues, variableData);

        return skyward.mvvm.newModel(variableData, undefined, function ()
        {
            var self = this;
            return {
                toJsonObject: function ()
                {
                    var result = {};
                    for (var key in defaultValues)
                    {
                        result[key] = self[key];
                    }
                    return result;
                },
                isInUse: function ()
                {
                    return self.setBy().length !== 0 || self.requiredBy().length !== 0 || self.resetBy().length !== 0;
                },
                isValidForAggregateMath: function ()
                {
                    return lookupTables.aggregateMathValidCategories.indexOf(self.dataTypeCategoryName) !== -1;
                },
                setBy: function ()
                {
                    return reportCanvas.find(".jsColumn[data-variable-id-to-set=" + self.uniqueId + "]");
                },
                requiredBy: function ()
                {
                    return self.gotBy().add(self.referredToBy());
                },
                gotBy: function ()
                {
                    return reportCanvas.find(".jsColumn[data-variable-id-to-get=" + self.uniqueId + "]");
                },
                referredToBy: function ()
                {
                    var variableColumns = self.gotBy();
                    var VARIABLE_COLUMN = skyward.reporting.COLUMN_TYPES.VARIABLE_COLUMN;
                    var CALCULATED_COLUMN = skyward.reporting.COLUMN_TYPES.CALCULATED_COLUMN;

                    var calculatedColumnUsesVariable = function ()
                    {
                        var columnsVisited = [];
                        var checkColumn = function (column)
                        {
                            var jqThis = $(column);
                            // Eliminate circular references
                            var bindingString = jqThis.attr("data-binding-string");
                            if (columnsVisited.indexOf(bindingString) !== -1)
                            {
                                return;
                            }
                            columnsVisited.push(bindingString);

                            var checkBinding = function (binding)
                            {
                                var variableColumnWithMatchingBinding = $(".jsColumn[data-variable-id-to-get='" + self.uniqueId + "'][data-binding-string='" + binding + "']");
                                if (variableColumnWithMatchingBinding.length)
                                {
                                    return true;
                                }

                                var foundVariableInCalculation = false;
                                var calculatedColumnWithMatchingBinding = $("[data-binding-string='" + binding + "'][data-field-column-type='" + CALCULATED_COLUMN + "']");
                                calculatedColumnWithMatchingBinding.each(function ()
                                {
                                    if (checkColumn(this))
                                    {
                                        foundVariableInCalculation = true;
                                    }
                                });
                                return foundVariableInCalculation;
                            };
                            var calculation = jqThis.data("calculation");
                            return checkBinding(calculation.LeftBinding) || checkBinding(calculation.RightBinding);
                        };

                        return checkColumn(this);
                    };
                    var calculatedColumns = reportCanvas.find("[data-field-column-type='" + CALCULATED_COLUMN + "']").filter(calculatedColumnUsesVariable);

                    return calculatedColumns.add(variableColumns);
                },
                resetBy: function ()
                {
                    return reportCanvas.find(".reportLine[data-variable-ids-to-reset*=" + self.uniqueId + "]");
                },
                getBindingString: function ()
                {
                    return "{_variable." + self.uniqueId + "}";
                },
                _variableModel_originalName: self.name,
                _variableModel_originalId: self.uniqueId
            };
        });
    };

    skyward.reporting.variables.init = function (variableCollectionData, view, canvas)
    {
        var templateContainer = view.find(".js-report-variable-templates").detach();
        var templates = {
            collection: templateContainer.find(".js-collection-template>*").detach(),
            item: {
                variable: templateContainer.find(".js-item-template> .variable").detach(),
                checkBoxVariable: templateContainer.find(".js-item-template> .checkBoxVariable").detach()
            },
            icons: templateContainer.find(".js-icon-template").detach(),
            listTarget: view.find(".js-list").clone()
        };

        var reportCanvas = canvas;
        var lookupTableElement = view.find(".dataTypeLookupTables");
        var lookupTables = JSON.parse(lookupTableElement.val());

        skyward.reporting.variables.collectionModel = skyward.reporting.variables.newVariableCollectionModel(variableCollectionData, lookupTables, reportCanvas);
        skyward.reporting.variables.viewModel = newVariableCollectionViewModel(skyward.reporting.variables.collectionModel, view);

        return {
            collectionModel: skyward.reporting.variables.collectionModel,
            viewModel: skyward.reporting.variables.viewModel
        };

        // View-models
        function newVariableViewModel(model, thisView)
        {
            return skyward.mvvm.newModel({ selected: false, checked: false }, { model: model, view: thisView }, function ()
            {
                var self = this;
                var observer = skyward.mvvm.newObserver();

                var nameControl = self.view.find(".js-name");
                var iconControl = self.view.find(".js-icon");
                var checkBox = self.view.find(".variableSelected");

                // Model -> View
                var modelNameChanged = function (val)
                {
                    nameControl.text(val);
                };
                var modelDataTypeCategoryNameChanged = function (val)
                {
                    iconControl.html(templates.icons.filter("[data-for-data-type-category-name='" + val + "']").children().show().clone());
                };
                // ViewModel -> View
                var selectedChanged = function (val)
                {
                    self.view.toggleClass("selected", val);
                };
                // View -> ViewModel
                var click = function ()
                {
                    self.selected = true;
                };
                var toggleCheck = function (checked)
                {
                    var bool = typeof checked === "boolean";

                    if (bool ? checked : !self.checked)
                    {
                        self.checked = true;
                    }
                    else
                    {
                        self.checked = false;
                    }

                    checkBox.prop("checked", self.checked);
                };

                observer.observe(model, "name", modelNameChanged);
                observer.observe(model, "dataTypeCategoryName", modelDataTypeCategoryNameChanged);
                observer.observe(self, "selected", selectedChanged);
                self.view.on("click", click);
                self.view.on("click", ".variableSelected", toggleCheck);

                modelNameChanged(model.name);
                modelDataTypeCategoryNameChanged(model.dataTypeCategoryName);

                self.view.data({ model: model, viewModel: self });

                var exposed = {
                    destroy: function ()
                    {
                        observer.stopObservingEverything();
                        return self.view.off().remove();
                    },
                    toggleCheck: function (checked)
                    {
                        toggleCheck(checked);
                    },
                    _variableViewModel_OriginalName: self.model.name,
                    _variableViewModel_OriginalId: self.model.uniqueId
                };

                return exposed;
            });
        }

        function newVariableCollectionViewModel(thisCollectionModel, thisView, options)
        {
            return skyward.mvvm.newModelCollection([], { collectionModel: thisCollectionModel, selectedModel: null }, { options: options, view: thisView }, function ()
            {
                var self = this;
                var options = this.options || {};
                var selectedViewModel = null;
                var observer = skyward.mvvm.newObserver();
                var filter = !options.dataTypeCategories ?
                    function () { return true; } : function (v) { return options.dataTypeCategories.indexOf(v.dataTypeCategoryName) !== -1; };

                var itemTemplate = options.useCheckBox === true ? templates.item.checkBoxVariable : templates.item.variable;
                var collectionView = templates.collection.clone();
                self.view.find(".js-list").replaceWith(collectionView);

                // View -> ViewModel
                var addClicked = function ()
                {
                    getNewVariableModel("Add Variable", options.dataTypeCategoryOnAdd)
                        .then(function (newModel)
                        {
                            return editVariable(self.collectionModel, newModel, "Add Variable");
                        })
                        .done(function (newModel)
                        {
                            if (newModel !== null)
                            {
                                self.collectionModel.add(newModel);
                            }
                        });
                };
                var editClicked = function ()
                {
                    editVariable(self.collectionModel, self.selectedModel, null, self.selectedModel.isInUse());
                };
                var deleteClicked = function ()
                {
                    self.collectionModel.remove(self.selectedModel);
                };
                var insertRequested = function (viewModel)
                {
                    self.announce("insertRequested", selectedViewModel.model, selectedViewModel.view);
                };
                const usageLocationsClicked = function ()
                {
                    self.announce("openUsageLocations", selectedViewModel.model);
                };
                // ViewModel -> View
                var selectedModelChanged = function (selectedModel, oldSelectedModel)
                {
                    if (selectedModel === oldSelectedModel)
                    {
                        return;
                    }
                    self.view.find(".js-selectedModel").toggleClass("ui-disabled", !selectedModel);
                    updateVariableUsageLocations();

                    // ViewModel -> ItemViewModels
                    self.isMuted = true;
                    self.forEach(function (itemViewModel)
                    {
                        itemViewModel.selected = itemViewModel.model === selectedModel;
                    });
                    self.isMuted = false;
                };
                // Model -> ViewModel
                var itemAdded = function (model)
                {
                    if (!filter(model))
                    {
                        return;
                    }
                    var itemView = itemTemplate.clone().appendTo(collectionView);

                    var itemViewModel = newVariableViewModel(model, itemView);
                    self.add(itemViewModel);
                    itemViewModel.selected = true;
                    return;
                };
                var itemRemoved = function (removedModel)
                {
                    var viewModel = self.find(function (i) { return i.model === removedModel; });
                    if (!viewModel)
                    {
                        return;
                    }

                    var viewModelIndex = self.indexOf(viewModel);
                    self.remove(viewModel).destroy();

                    if (viewModelIndex < self.length)
                    {
                        self.elementAt(viewModelIndex).selected = true;
                    }
                    else if (self.length !== 0)
                    {
                        self.elementAt(viewModelIndex - 1).selected = true;
                    }
                    else
                    {
                        self.selectedModel = null;
                    }
                };
                // ItemViewModel -> ViewModel
                var itemViewModelSelected = function (changingViewModel)
                {
                    if (changingViewModel.selected)
                    {
                        selectedViewModel = changingViewModel;
                        self.selectedModel = changingViewModel.model;
                    }
                    else
                    {
                        self.selectedModel = null;
                        selectedViewModel = null;
                    }
                };

                const updateVariableUsageLocations = function ()
                {
                    if (self.selectedModel)
                    {
                        const usageLocationsButton = self.view.find(".usage_locations");
                        if (usageLocationsButton.length !== 0)
                        {
                            usageLocationsButton.toggleClass("ui-disabled", !self.selectedModel.isInUse());
                        }
                    }
                };

                // bind up
                self.view.on("click", ".add_variable:not(.ui-disabled)", null, addClicked);
                self.view.on("click", ".edit_variable:not(.ui-disabled)", null, editClicked);
                self.view.on("click", ".delete_variable:not(.ui-disabled)", null, deleteClicked);
                self.view.on("click", ".usage_locations:not(.ui-disabled)", null, usageLocationsClicked);
                self.view.on("dblclick", ".selected", null, insertRequested);
                observer.observe(self, "model:selected", itemViewModelSelected);
                observer.observe(self, "model:dblclick", insertRequested);
                observer.observe(self, "selectedModel", selectedModelChanged);
                observer.observe(self.collectionModel, "add", itemAdded);
                observer.observe(self.collectionModel, "remove", itemRemoved);

                // add items
                self.collectionModel.forEach(itemAdded);

                if (options.additionalEntries)
                {
                    $.each(options.additionalEntries, function (i, v) { itemAdded(v); });
                }
                // select first entry
                if (self.length > 0)
                {
                    self.elementAt(0).selected = true;
                }

                var exposed = {
                    destroy: function ()
                    {
                        self.forEach(function (variableViewModel)
                        {
                            variableViewModel.destroy();
                        });
                        observer.stopObservingEverything();

                        return self.view.off().remove();
                    },
                    observe: observer.observe,
                    getIcon: function (variable)
                    {
                        return templates.icons.filter("[data-for-data-type-category-name='" + variable.dataTypeCategoryName + "']").clone();
                    },
                    selectVariableToSet: function (dataTypeCategoryName, anchorTo, newVariableName, allowAddNewVar = true)
                    {
                        restrictToCategories = lookupTables.categoriesThatCanBeSetByCategory[dataTypeCategoryName];
                        return selectVariableToSet(self.collectionModel, restrictToCategories, dataTypeCategoryName, anchorTo, newVariableName, allowAddNewVar);
                    },
                    selectVariablesToReset: function (variablesToResetElement, variablesIDsToReset, variablesToResetViewModel)
                    {
                        return selectVariablesToReset(self.collectionModel, variablesToResetElement, variablesIDsToReset, variablesToResetViewModel);
                    },
                    getVariableViewModel: function (uniqueID)
                    {
                        var variableViewModule;
                        self.forEach(function (value)
                        {
                            if (value.model.uniqueId === uniqueID)
                            {
                                variableViewModule = value;
                                return false;
                            }
                        });
                        return variableViewModule;
                    },
                    updateVariableUsageLocations: function ()
                    {
                        updateVariableUsageLocations();
                    },
                    _variableCollectionViewModel: options.name || "no name"
                };
                return exposed;
            });
        }

        function selectVariableToSet(collectionModel, restrictToTypes, dataTypeCategoryName, anchorTo, newVariableName, allowAddNewVar = true)
        {
            var waitForSelection = $.Deferred();

            restrictToTypes = restrictToTypes || [];
            restrictToTypes.push("null"); // This prevents filtering out the model for "Do not set a variable."

            var selectorView = $("<div/>").append(templates.listTarget.clone());
            var viewModelOptions = {
                dataTypeCategories: restrictToTypes,
                dataTypeCategoryOnAdd: dataTypeCategoryName,
                additionalEntries: [skyward.reporting.variables.newVariableModel({ name: "Do not set a variable", dataTypeCategoryName: "null", uniqueId: "" }, lookupTables, reportCanvas)],
                name: "Selector"
            };
            var selectorViewModel = newVariableCollectionViewModel(collectionModel, selectorView, viewModelOptions);
            selectorViewModel.view.find(".treebrowserow, .treebrowse").removeClass("treebrowserow treebrowse");
            selectorViewModel.view.on("dblclick", ".selected", null, function () { confirmSelection(); });

            var addingNewVariable = false;
            var addVariableAndSetSelector = function ()
            {
                addingNewVariable = true;
                modalLayer.close();

                getNewVariableModel(newVariableName || "Add Variable", dataTypeCategoryName)
                    .then(function (newModel)
                    {
                        return editVariable(collectionModel, newModel, "Add Variable", false, restrictToTypes);
                    })
                    .done(function (newModel)
                    {
                        if (newModel !== null)
                        {
                            collectionModel.add(newModel);
                            waitForSelection.resolve(newModel);
                        }
                        else
                        {
                            waitForSelection.reject();
                        }
                    });
            };
            var confirmSelection = function ()
            {
                waitForSelection.resolve(selectorViewModel.selectedModel);
                modalLayer.close();
            };
            var layerClosed = function ()
            {
                if (!addingNewVariable && waitForSelection.state() === "pending")
                {
                    waitForSelection.reject();
                }
                selectorViewModel.destroy();
            };

            var addButton = { text: "Add Variable", icon: "AddPlus", click: addVariableAndSetSelector };
            var okButton = { text: "Save", icon: "Save", click: confirmSelection };
            var cancelButton = { text: "Cancel", icon: "Cancel", click: "close" };
            var buttons = [];
            if (allowAddNewVar)
            {
                buttons.push(addButton);
            }
            buttons.push(okButton, cancelButton);
            var options = {
                afterClose: layerClosed,
                closeOnClick: false,
                anchorTo: anchorTo
            };
            var modalLayer = skyward.modalLayer.showDialog("Select a Variable", selectorView, buttons, options);

            return waitForSelection.promise();
        }

        function selectVariablesToReset(collectionModel, element, variablesIDsToReset, variablesToResetViewModel)
        {
            var selectorView = $("<div/>").append(templates.listTarget.clone());
            var viewModelOptions = {
                useCheckBox: true
            };
            if (!variablesToResetViewModel.length)
            {
                variablesToResetViewModel = newVariableCollectionViewModel(collectionModel, selectorView, viewModelOptions);
            }

            collectionModel.forEach(function (value)
            {
                variablesToResetViewModel.getVariableViewModel(value.uniqueId).toggleCheck(false);
            });

            variablesIDsToReset.forEach(function (value)
            {
                variablesToResetViewModel.getVariableViewModel(value).toggleCheck(true);
            });

            element.find(".js-list").replaceWith(variablesToResetViewModel.view);

            return variablesToResetViewModel;
        }

        function loadEditorTemplate()
        {
            return $.when(
                templates.editor ||
                $.ajax({
                    url: skyward.global.virtualDir + "Reporting/Report/GetVariableEditorTemplate/",
                    type: "POST",
                    dataType: "JSON",
                    success: function (data)
                    {
                        templates.editor = $(data.editor)
                    }
                }));
        }

        function getDefaultValueInputForType(defaultValueInputs, dataType)
        {
            return defaultValueInputs.find(`.js-defaultValueInput[data-default-value-data-type='${dataType}']`);
        }

        // Shared functionality
        function getNewVariableModel(name, dataTypeCategoryName)
        {
            var waitForServer = $.Deferred();
            $.ajax(skyward.global.virtualDir + "Reporting/Report/NewVariableId",
                {
                    type: "POST",
                    dataType: "JSON",
                    data: { name: name, dataTypeCategoryName: dataTypeCategoryName },
                    success: function (data)
                    {
                        waitForServer.resolve(skyward.reporting.variables.newVariableModel(data, lookupTables, reportCanvas), "Add Variable");
                    }
                }).fail(waitForServer.reject);
            return waitForServer.promise();
        }

        function editVariable(collectionModel, model, popupTitle, isInUse, restrictToTypes)
        {
            popupTitle = popupTitle || "Edit Variable";
            const waitForEditor = $.Deferred();

            loadEditorTemplate()
                .then(function ()
                {
                    let modalLayer;
                    const editor = templates.editor.clone();
                    const nameInput = editor.find(".js-name");
                    const dataTypeInput = editor.find(".js-dataTypeCategoryName");
                    const defaultValueInputs = editor.find(".js-defaultValueInputs");
                    const dataTypeChangeHandler = function ()
                    {
                        defaultValueInputs.find(".js-defaultValueInput").each(async function ()
                        {
                            const self = $(this);
                            skyward.controls.hide(self, false);
                            // Vue rendered controls cannot be updated until the DOM has loaded them (they are client rendered)
                            await modalLayer?.bodyPromise;
                            skyward.controls.clearValue(self);                            
                        });

                        let defaultValueInput = getDefaultValueInputForType(defaultValueInputs, dataTypeInput.val());
                        skyward.controls.show(defaultValueInput, false);
                        skyward.controls.setValue(defaultValueInput, model.defaultValue);
                    }

                    skyward.window.notifyDOMLoad(editor);

                    nameInput.val(model.name);
                    dataTypeInput.on("change", dataTypeChangeHandler);
                    skyward.controls.setValue(dataTypeInput, model.dataTypeCategoryName);

                    if (isInUse)
                    {
                        dataTypeInput.addClass("ui-disabled").get(0).disabled = true;
                    }
                    if (restrictToTypes)
                    {
                        dataTypeInput.children().filter(function (i, e) { return restrictToTypes.indexOf($(e).val()) === -1; }).remove();
                    }

                    let okClicked = function ()
                    {

                        let name = nameInput.val();
                        let errors = {};

                        if (!Boolean(name))
                        {
                            errors["variableName"] = ["Name is a required field."];
                        }

                        if (collectionModel.nameExists(name, model.uniqueId))
                        {
                            errors["variableName"] = ["This name is already in use."];
                        }

                        if (!$.isEmptyObject(errors))
                        {
                            skyward.validation.displayValidationMessages({ errors: errors }, modalLayer.content, $());
                            return;
                        }
                        else
                        {
                            model.name = name;
                            model.dataTypeCategoryName = dataTypeInput.val();
                            //defaultValue does not need to be encoded currently. It will be encoded before being posted on save.
                            model.defaultValue = skyward.controls.getUnencodedValue(getDefaultValueInputForType(defaultValueInputs, dataTypeInput.val()));
                            waitForEditor.resolve(model);
                        }
                        modalLayer.close();
                    };
                    let layerClosed = function ()
                    {
                        if (waitForEditor.state() === "pending")
                        {
                            waitForEditor.reject();
                        }
                    };
                    let okButton = { text: "Save", "icon": "Save", "click": okClicked };
                    let cancelButton = { text: "Cancel", "icon": "Cancel", "click": "close" };
                    modalLayer = skyward.modalLayer.showDialog(popupTitle, editor, [okButton, cancelButton], { afterClose: layerClosed, closeOnClick: false });
                    modalLayer.bodyPromise.done(function ()
                    {
                        nameInput.focus();
                    });
                });
            return waitForEditor.promise();
        }
    };
}(window.skyward = window.skyward || {}, window.jQuery));